export default {"src":"/_next/static/media/ck.9c0aeefb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};